import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=aafe7bee&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=aafe7bee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aafe7bee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aafe7bee')) {
      api.createRecord('aafe7bee', component.options)
    } else {
      api.reload('aafe7bee', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=aafe7bee&scoped=true&", function () {
      api.rerender('aafe7bee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-22I4Ey5vyGV0W/JS/comp/DocBox.vue"
export default component.exports